import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import classNames from "classnames";
import messages from "./messages";
import { decodeText, treatBlankQuestionsByStudentBlock } from "../../lib/react-util";
import AssessmentRubric from "../../components/AssessmentRubric";
import { api } from "../../lib/api";

import "./AssessmentAnswers.scss";

function parseMedia(text) {
  return text
    ? text.replace(/=(&quot;|"|')\/cp\/cpdata\/uploads/g, `=$1${process.env.REACT_APP_FILES_API}`)
    : "";
}
class AssessmentAnswers extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showButton: false, // Armazena o estado de cada questão
    };
  }
  componentDidUpdate(prevProps) {
    const { questions, idAttempt } = this.props;

    // Verifica se o idAttempt está preenchido e mudou
    if (idAttempt && idAttempt !== prevProps.idAttempt && questions) {
      questions.forEach(data => {
        if (data.context) {
          data.context.questions.forEach(q => {
            if (Number(q.idType) === 3) {
              this.loadAnswerImage(q.id, idAttempt);
            }
          });
        } else if (data.question && Number(data.question.idType) === 3) {
          this.loadAnswerImage(data.question.id, idAttempt);
        }
      });
    }
  }

  async loadAnswerImage(idQuestion, idAttempt) {
    try {
      const response = await api.get("/assessments/viewAnswerFile.php", {
        params: { idQuestion, idAttempt },
        responseType: "arraybuffer", // Recebe a imagem como um buffer
      });

      // Converte o buffer da imagem para base64
      let base64Image = null;
      if (response.data.byteLength > 0) {
        base64Image = `data:image/jpeg;base64,${btoa(
          new Uint8Array(response.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            "",
          ),
        )}`;
      }

      // Atualiza o conteúdo do bloco com a imagem
      if (base64Image) {
        const element = document.getElementById(`answer-${idQuestion}`);
        if (element) {
          element.innerHTML += `<img src="${base64Image}" alt="Uploaded Image" />`;
          this.setState(() => ({
            showButton: true,
          }));
        }
      }
    } catch (error) {
      console.error("Erro ao carregar a imagem:", error);
    }
  }

  render() {
    const { questions, role, intl } = this.props;

    if (!questions || questions.length === 0) {
      return (
        <p style={{ textAlign: "center" }}>
          <FormattedMessage {...messages.noData} />
        </p>
      );
    }

    const allQuestions = questions.flatMap(data => data.context ? data.context.questions : [data.question]);
    const isRubricAssessment = allQuestions.every(q => q.idType === "6");

    if (isRubricAssessment) {
      return <AssessmentRubric data={questions} />;
    }

    return (
      <div className="allQuestions">
        {questions.map((data, index) =>
          data.context ? (
            <div>
              <div
                className={classNames(
                  "question-context",
                  data.context.questions.some(q => q.cursiveLetter == "1") && "question-cursive",
                )}
                dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(data.context.text)) }}
                // style={{ paddingBottom: "40px" }}
              />
              {data.context.questions.map(q => {
                let questionEnunc =
                  q && q.text
                    ? q.text.replace(
                        /=(&quot;|"|')\/cp\/cpdata\/uploads/g,
                        `=$1${process.env.REACT_APP_FILES_API}`,
                      )
                    : "";
                questionEnunc = decodeText(questionEnunc);
                questionEnunc = questionEnunc ? questionEnunc.replace(/&quot;/g, "") : "";

                const isQuestionCanceled = q && q.isQuestionCanceled ? q.isQuestionCanceled : false;
                return (
                  <div className="question-unitary-context" key={index}>
                    <div className="question-block">
                      <div className="question-number">
                        <div className={`badge-dark${isQuestionCanceled ? ' bg-red' : ''}`}>{q.questionNumber}</div>
                      </div>
                      <div className="question-item">
                        {Number(q.idType) === 3 && (
                          <div className="fixed-actions">
                            {role === 4 ? (
                              q.alternatives[0] && q.alternatives[0].answerGrade ? (
                                <span className="grade">
                                  {q.alternatives[0]
                                    ? q.alternatives[0].answerGrade
                                      ? this.props.intl.formatNumber(q.alternatives[0].answerGrade)
                                      : ""
                                    : ""}
                                </span>
                              ) : (
                                <span
                                  className="grade notQualified"
                                  title={this.props.intl.formatMessage(
                                    messages.pendingQualification,
                                  )}
                                >
                                  <span className="pe-7s-attention"></span>
                                </span>
                              )
                            ) : (
                              <span className="grade">
                                {q.alternatives[0]
                                  ? q.alternatives[0].answerGrade
                                    ? this.props.intl.formatNumber(q.alternatives[0].answerGrade)
                                    : ""
                                  : ""}
                              </span>
                            )}
                            {this.props.hasUserEditGradePermission && this.props.onEditGrade && (
                              <button
                                onClick={() =>
                                  this.props.onEditGrade(
                                    q.id,
                                    q.alternatives[0] ? q.alternatives[0].answerGrade : null,
                                  )
                                }
                              >
                                <i className="ti-pencil" />
                                {this.props.intl.formatMessage(messages.editGrade)}
                              </button>
                            )}
                            {this.props.hasUserEditGradePermission &&
                            this.props.onEditGrade &&
                            q.alternatives[0] &&
                            q.alternatives[0].answerGrade ? (
                              <button onClick={() => this.props.onRemoveGrade(q.id)}>
                                <i className="fa fa-ban" />
                                {this.props.intl.formatMessage(messages.removeGrade)}
                              </button>
                            ) : (
                              ""
                            )}
                          </div>
                        )}

                        <div
                          className={classNames(
                            "enunc",
                            q.cursiveLetter == "1" && "question-cursive",
                          )}
                          dangerouslySetInnerHTML={{
                            __html: parseMedia(questionEnunc),
                          }}
                        />

                        <div className="question-answer">
                          {Number(q.idType) === 0 && intl.locale !== "es-es" && (
                            <p>
                              <FormattedMessage
                                {...messages.right}
                                style={{ fontWeight: "normal" }}
                              />
                            </p>
                          )}
                          {Number(q.idType) === 1 && intl.locale !== "es-es" && (
                            <p>
                              <FormattedMessage
                                {...messages.rightAll}
                                style={{ fontWeight: "normal" }}
                              />
                            </p>
                          )}
                          {Number(q.idType) === 3 && (
                            <div>
                              {this.state.showButton && (
                                <button
                                  className="btn-download"
                                  onClick={async () => {
                                    try {
                                      const response = await api.get(
                                        "/assessments/viewAnswerFile.php",
                                        {
                                          params: {
                                            idQuestion: q.id,
                                            idAttempt: this.props.idAttempt,
                                          },
                                          responseType: "blob", // Recebe o arquivo como um blob
                                        },
                                      );

                                      // Cria um link para download
                                      const url = window.URL.createObjectURL(
                                        new Blob([response.data]),
                                      );
                                      const link = document.createElement("a");
                                      link.href = url;
                                      link.setAttribute("download", `answer-${q.id}.jpg`); // Nome do arquivo
                                      document.body.appendChild(link);
                                      link.click();
                                      link.remove();
                                    } catch (error) {
                                      console.error("Erro ao fazer download da imagem:", error);
                                      alert("Erro ao fazer download da imagem.");
                                    }
                                  }}
                                >
                                  {this.props.intl.formatMessage(messages.download)}
                                </button>
                              )}
                              <div className="open-question" id={`answer-${q.id}`}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: q.alternatives[0] ? q.alternatives[0].answerText : "",
                                  }}
                                />
                              </div>
                            </div>
                          )}
                          {Number(q.idType) === 4 && (
                            <div className="h5p-content">
                              <span className="grade-h5p">{q.alternatives[0].answerGrade}</span>
                              <iframe
                                src={`${q.h5pFileLink}`}
                                height="430"
                                width="100%"
                                style={{ border: " 1px solid #aaaaaa" }}
                              ></iframe>
                            </div>
                          )}
                          <ul
                          // style={{
                          //   margin: "5px 40px",
                          // }}
                          >
                            {helpers.handlerSort(q.alternatives, helpers.compare).length > 0 &&
                              Number(q.idType) !== 3 &&
                              helpers.handlerSort(q.alternatives, helpers.compare).map((a, i) => (
                                <li
                                  key={`alt-${i}`}
                                  type="a"
                                  className={"enunc-alt"}
                                  style={{ position: "relative" }}
                                >
                                  <div className={`divFlex ${a.correct === "1" && "borderGreen"}`}>
                                    {q.idType === "2" && (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: treatBlankQuestionsByStudentBlock(
                                            a.text,
                                            a.blanks,
                                            a.answers,
                                          ),
                                        }}
                                      />
                                    )}
                                    {q.idType <= "1" && (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: decodeText(a.text),
                                        }}
                                      />
                                    )}
                                    {a.answered && a.correct !== "1" && (
                                      <i
                                        className="fas fa-times positionBefore wrong"
                                        style={{ color: "#eb472b" }}
                                      />
                                    )}
                                    {a.answered && a.correct === "1" && (
                                      <i
                                        className="fas fa-check positionBefore"
                                        style={{ color: "#108E31" }}
                                      />
                                    )}
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {isQuestionCanceled ? (
                      <div className="question-canceled">{this.props.intl.formatMessage(messages.canceled)}</div>
                    ) : ''}
                  </div>
                );
              })}
            </div>
          ) : (
            data.question && (
              <div
                className={classNames(
                  "question-unitary",
                  data.question.cursiveLetter == "1" && "question-cursive",
                )}
                key={index}
              >
                <div className="question-block">
                  <div className="question-number">
                    <div className={`badge-dark${data.question.isQuestionCanceled !== null ? ' bg-red' : ''}`}>{data.question.questionNumber}</div>
                  </div>
                  <div className="question-item">
                    {Number(data.question.idType) === 3 && (
                      <div className="fixed-actions">
                        {role === 4 ? (
                          data.question.alternatives[0] &&
                          data.question.alternatives[0].answerGrade ? (
                            <span className="grade">
                              {data.question.alternatives[0]
                                ? data.question.alternatives[0].answerGrade
                                  ? this.props.intl.formatNumber(
                                      data.question.alternatives[0].answerGrade,
                                    )
                                  : ""
                                : ""}
                            </span>
                          ) : (
                            <span
                              className="grade notQualified"
                              title={this.props.intl.formatMessage(messages.pendingQualification)}
                            >
                              <span className="pe-7s-attention"></span>
                            </span>
                          )
                        ) : (
                          <span className="grade">
                            {data.question.alternatives[0]
                              ? data.question.alternatives[0].answerGrade
                                ? this.props.intl.formatNumber(
                                    data.question.alternatives[0].answerGrade,
                                  )
                                : ""
                              : ""}
                          </span>
                        )}
                        {this.props.hasUserEditGradePermission && this.props.onEditGrade && (
                          <button
                            onClick={() =>
                              this.props.onEditGrade(
                                data.question.id,
                                data.question.alternatives[0]
                                  ? data.question.alternatives[0].answerGrade
                                  : null,
                              )
                            }
                          >
                            <i className="ti-pencil" />
                            {this.props.intl.formatMessage(messages.editGrade)}
                          </button>
                        )}
                        {this.props.hasUserEditGradePermission &&
                        this.props.onEditGrade &&
                        data.question.alternatives[0] &&
                        data.question.alternatives[0].answerGrade ? (
                          <button onClick={() => this.props.onRemoveGrade(data.question.id)}>
                            <i className="fa fa-ban" />
                            {this.props.intl.formatMessage(messages.removeGrade)}
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    <div
                      className="enunc"
                      dangerouslySetInnerHTML={{
                        __html: parseMedia(decodeText(data.question.text)),
                      }}
                    />
                    <div className="question-answer">
                      {Number(data.question.idType) === 0 && intl.locale !== "es-es" && (
                        <p>
                          <FormattedMessage {...messages.right} style={{ fontWeight: "unset" }} />
                        </p>
                      )}
                      {Number(data.question.idType) === 1 && intl.locale !== "es-es" && (
                        <p>
                          <FormattedMessage
                            {...messages.rightAll}
                            style={{ fontWeight: "unset" }}
                          />
                        </p>
                      )}

                      {Number(data.question.idType) === 3 && (
                        <div>
                          {this.state.showButton && (
                            <button
                              className="btn-download"
                              onClick={async () => {
                                try {
                                  const response = await api.get(
                                    "/assessments/viewAnswerFile.php",
                                    {
                                      params: {
                                        idQuestion: data.question.id,
                                        idAttempt: this.props.idAttempt,
                                      },
                                      responseType: "blob", // Recebe o arquivo como um blob
                                    },
                                  );

                                  // Cria um link para download
                                  const url = window.URL.createObjectURL(new Blob([response.data]));
                                  const link = document.createElement("a");
                                  link.href = url;
                                  link.setAttribute("download", `answer-${data.question.id}.jpg`); // Nome do arquivo
                                  document.body.appendChild(link);
                                  link.click();
                                  link.remove();
                                } catch (error) {
                                  console.error("Erro ao fazer download da imagem:", error);
                                  alert("Erro ao fazer download da imagem.");
                                }
                              }}
                            >
                              {this.props.intl.formatMessage(messages.download)}
                            </button>
                          )}
                          <div className="open-question" id={`answer-${data.question.id}`}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: data.question.alternatives[0]
                                  ? data.question.alternatives[0].answerText
                                  : "",
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {Number(data.question.idType) === 4 && (
                        <div className="h5p-content">
                          <span className="grade-h5p">
                            {data.question.alternatives[0].answerGrade}
                          </span>
                          <iframe
                            src={`${data.question.h5pFileLink}`}
                            height="430"
                            width="100%"
                            style={{ border: " 1px solid #aaaaaa" }}
                          ></iframe>
                        </div>
                      )}
                      <ul
                      // style={{
                      //   margin: "5px 40px",
                      // }}
                      >
                        {helpers.handlerSort(data.question.alternatives, helpers.compare).length >
                          0 &&
                          Number(data.question.idType) !== 3 &&
                          Number(data.question.idType) !== 4 &&
                          helpers
                            .handlerSort(data.question.alternatives, helpers.compare)
                            .map((a, i) => (
                              <li
                                key={`alt-${i}`}
                                type="a"
                                className={"enunc-alt"}
                                style={{ position: "relative" }}
                              >
                                <div className={`divFlex ${a.correct === "1" && "borderGreen"}`}>
                                  {data.question.idType === "2" && (
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: treatBlankQuestionsByStudentBlock(
                                          a.text,
                                          a.blanks,
                                          a.answers,
                                        ),
                                      }}
                                    />
                                  )}
                                  {(data.question.idType <= "1" ||
                                    data.question.idType === "5") && (
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: parseMedia(decodeText(a.text)),
                                      }}
                                    />
                                  )}
                                  {data.question.idType === "5" && (
                                    <span>
                                      <p>{`(${a.grade})`}</p>
                                    </span>
                                  )}
                                  {a.answered &&
                                    (a.correct !== "1" || data.question.idType === "5") && (
                                      <i
                                        className="fas fa-times positionBefore"
                                        style={{ color: "#eb472b" }}
                                      />
                                    )}
                                  {a.answered &&
                                    (a.correct === "1" || data.question.idType === "5") && (
                                      <i
                                        className="fas fa-check positionBefore"
                                        style={{ color: "#108E31" }}
                                      />
                                    )}
                                </div>
                              </li>
                            ))}
                      </ul>
                    </div>
                  </div>
                </div>
                {data.question.isQuestionCanceled !== null ? (
                  <div className="question-canceled">{this.props.intl.formatMessage(messages.canceled)}</div>
                ) : ''}

                {/* <div className="badge-dark">{data.question.questionNumber}</div> */}
                {/* <h3
                    className={"enunc"}
                    dangerouslySetInnerHTML={{
                      __html: parseMedia(decodeText(data.question.text)),
                    }}
                  /> */}
                {/* {this.props.onEditGrade && Number(data.question.idType) === 3 && (
                    <div className="fixed-actions">
                      <span className="grade">{data.question.alternatives[0] ? data.question.alternatives[0].answerGrade ? this.props.intl.formatNumber(data.question.alternatives[0].answerGrade) : '' : ''}
                      </span>
                      <button onClick={() => this.props.onEditGrade(data.question.id, data.question.alternatives[0] ? data.question.alternatives[0].answerGrade : null)}>
                        <i className="ti-pencil" />
                        {this.props.intl.formatMessage(messages.editGrade)}
                      </button>
                      {data.question.alternatives[0] && data.question.alternatives[0].answerGrade ? 
                        <button onClick={() => this.props.onRemoveGrade(data.question.id)}>
                          <i className="fa fa-ban" />
                          {this.props.intl.formatMessage(messages.removeGrade)}
                        </button>
                        : ''
                      }
                    </div>
                  )} */}
                {/* <div style={{ padding: "0 10px" }}>
                    {Number(data.question.idType) === 0 && 
                      <p>
                        <FormattedMessage {...messages.right} style={{ fontWeight: "unset" }} />
                      </p>
                    }
                    {Number(data.question.idType) === 1 && 
                      <p>
                        <FormattedMessage {...messages.rightAll} style={{ fontWeight: "unset" }} />
                      </p>
                    }
                    
                    {Number(data.question.idType) === 3 && (
                        <div className="open-question">
                          {data.question.alternatives[0] ? data.question.alternatives[0].answerText : ''}
                        </div>
                      )}
                      {Number(data.question.idType) === 4 && (
                        <div className="h5p-content">
                          <span className="grade-h5p">{data.question.alternatives[0].answerGrade}</span>
                          <iframe src={`${data.question.h5pFileLink}`} height="430" width="100%" style={{border:" 1px solid #aaaaaa"}}></iframe>
                        </div>
                      )}
                    <ul
                      style={{
                        margin: "5px 40px",
                      }}
                    >
                      {helpers.handlerSort(data.question.alternatives, helpers.compare).length >
                        0 && Number(data.question.idType) !== 3 &&  Number(data.question.idType) !== 4 &&
                        helpers
                          .handlerSort(data.question.alternatives, helpers.compare)
                          .map((a, i) => (
                            <li
                              key={`alt-${i}`}
                              type="a"
                              className={"enunc-alt"}
                              style={{ position: "relative" }}
                            >
                              <div className={`divFlex ${a.correct === "1" && "borderGreen"}`}>
                                {data.question.idType === "2" && 
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: treatBlankQuestionsByStudentBlock(a.text, a.blanks, a.answers)
                                    }}
                                  />
                                }
                                {data.question.idType <= "1" && 
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: parseMedia(decodeText(a.text))
                                    }}
                                  />
                                }
                                {a.answered && a.correct !== "1" && (
                                  <i
                                    className="fas fa-times positionBefore"
                                    style={{ color: "#eb472b" }}
                                  />
                                )}
                                {a.answered && a.correct === "1" && (
                                  <i
                                    className="fas fa-check positionBefore"
                                    style={{ color: "#108E31" }}
                                  />
                                )}
                              </div>
                            </li>
                          ))}
                    </ul>
                  </div> */}
              </div>
            )
          ),
        )}
      </div>
    );
  }
}

AssessmentAnswers.propTypes = {};

AssessmentAnswers.defaultProps = {
  questions: null,
};

const helpers = {
  compare: (a, b) => {
    if (a.position < b.position) return -1;
    if (a.position > b.position) return 1;
    return 0;
  },
  handlerSort: (array, method) => {
    const newArray = array.sort(method);
    return newArray;
  },
};

export default injectIntl(AssessmentAnswers);
